<template lang="pug">
.container
  .section(v-if='desktopGroups.length > 1')
    h4 {{ $t('This Device has Desktops in different Groups. Please set schedule for Groups, not for Device itself.')}}
  .section(v-if='desktopGroups.length <= 1')
    .row(v-if='desktopGroups.length === 1')
      hr.header
      .send-button(style='text-align:right')
        el-button(id="EditSchedule-groupRequestUpdateButton", type='success', size='mini', @click='sendOnDemandScheduleRequest(true, desktopGroups[0])', :disabled='sendingOnDemandScheduleRequestsToGroup')
          font-awesome-icon(icon="upload")
          span(v-if='!sendingOnDemandScheduleRequestsToGroup') &nbsp; {{ $t('Send update schedule request to all devices in group') }}
          span(v-else) &nbsp; {{ $t('sending...') }}
      h4.center {{ $t('Group Schedule ')}} - {{ desktopGroups[0].name }}:
      ScheduleDateEditor(id="EditSchedule-groupScheduleDateEditor", :item='desktopGroups[0]', model="DeviceDesktopGroup")
      ScheduleDayTimeEditor(id="EditSchedule-groupScheduleDayTimeEditor", :item='desktopGroups[0]', model="DeviceDesktopGroup")
      ScheduleHolidayEditor(id="EditSchedule-groupHolidayEditor", :item='desktopGroups[0]', model="DeviceDesktopGroup")
    .row
      hr.header
      .send-button(style='text-align:right')
        el-button(id="EditSchedule-deviceRequestUpdateButton", type='success', size='mini', @click='sendOnDemandScheduleRequest(false, newEditedDevice)', :disabled='sendingOnDemandScheduleRequestToDevice')
          font-awesome-icon(icon="upload")
          span(v-if='!sendingOnDemandScheduleRequestToDevice') &nbsp; {{ $t('Send update schedule request to this device') }}
          span(v-else) &nbsp; {{ $t('sending...') }}
      h4.center {{ $t('Device Schedule:')}}
      h4.warning.center(v-if='groupHasSomeSchedule && deviceHasSomeSchedule')
        span {{ $t('Additional times for this device')}}
      ScheduleDateEditor(id="EditSchedule-deviceScheduleDateEditor", :item='newEditedDevice', model="Device")
      ScheduleDayTimeEditor(id="EditSchedule-deviceScheduleDayTimeEditor", :item='newEditedDevice', model="Device")
      ScheduleHolidayEditor(id="EditSchedule-deviceScheduleHolidayEditor", :item='newEditedDevice', model="Device")
</template>

<script>

import Vue from 'vue'
import deviceUtils from '../Common/deviceUtils.mixin'
import ScheduleDateEditor from '../Common/ScheduleDateEditor'
import ScheduleDayTimeEditor from '../Common/ScheduleDayTimeEditor'
import ScheduleHolidayEditor from '../Common/ScheduleHolidayEditor'

export default {
  components: {
    ScheduleDateEditor,
    ScheduleDayTimeEditor,
    ScheduleHolidayEditor
  },
  mixins: [deviceUtils],
  props: ['newEditedDevice'],
  async created () {
    const ddgroupIds = this.newEditedDevice.DeviceDesktops.map(dd => dd.DeviceDesktopGroup)
    if (ddgroupIds[0] === null) return
    this.desktopGroups = await Vue.axios
      .get(`/devicedesktopgroup?where={"id":{"in":${JSON.stringify(ddgroupIds)}}}`)
      .then(response => {
        return response.data
      })
  },
  data () {
    return {
      errors: {
      },
      desktopGroups: []
    }
  },
  methods: {
  },
  computed: {
    groupHasSomeSchedule () {
      if (!this.desktopGroups[0] || this.desktopGroups.length === 0) return false
      return this.desktopGroups[0].DeviceDesktopGroup_DaytimeRestrictions.length > 0 ||
        this.desktopGroups[0].DeviceDesktopGroup_DateRestrictions.length > 0
    },
    deviceHasSomeSchedule () {
      return this.newEditedDevice.Device_DaytimeRestrictions.length > 0 ||
        this.newEditedDevice.Device_DateRestrictions.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/EditSchedule.vue